import axios from "axios";
import React, { useEffect, useState } from "react";
import { api } from "../utils/Api";
import { Typography, Flex, Button, notification } from "antd";
import Layout from "../layout/Layout";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import { EditFilled, PlusCircleFilled } from "@ant-design/icons";
const { Text } = Typography;

const SupplierList = ({ history }) => {
	const [loading, setLoading] = useState(true);
	const [supplierList, setSupplierList] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	/**
	 ** Options header (columns)
	 */
	const columns = [
		{
			title: "",
			dataIndex: "edit",
			width: 100,
			render: (_, record) => {
				return (
					<Flex justify="space-between">
						{localStorage.getItem("email") === "eliud@gmail.com" ? (
							<Button
								type="primary"
								icon={<EditFilled twoToneColor={"white"} />}
								onClick={(e) => history.push(`/supplier/update/${record.id}`)}
							/>
						) : (
							""
						)}
					</Flex>
				);
			},
		},
		{
			title: "Name",
			dataIndex: "name",
			key: "name",
			render: (value) => {
				return <Text>{value}</Text>;
			},
		},
	];

	useEffect(() => {
		console.log("entre");
		getSupplierList();
	}, []);

	const getSupplierList = async () => {
		setLoading(true);

		const url = api + `/supplier/get/list`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let list = [];
			if (data.success) {
				data.payload.map((item, index) => {
					list.push({
						key: index,
						id: item._id,
						name: item.name,
					});
				});
				setSupplierList(list);
			} else {
				openNotification("error", "Error", data.message);
			}
			setLoading(false);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const addNewSupplier = () => {
		history.push("/supplier/new");
	};

	const RenderTable = () => {
		return (
			<Flex gap={"middle"} vertical>
				{localStorage.getItem("email") === "eliud@gmail.com" && (
					<Button
						onClick={addNewSupplier}
						type="primary"
						style={{
							width: 150,
						}}
						icon={<PlusCircleFilled />}
						size="large"
					>
						New Supplier
					</Button>
				)}
				<CustomTable columns={columns} data={supplierList} isScroll={false} />
			</Flex>
		);
	};

	return (
		<Layout title="Supplier" description="Supplier List">
			<Flex vertical gap={"large"}>
				{loading ? <CustomSpinner /> : <RenderTable />}
				{contextHolder}
			</Flex>
		</Layout>
	);
};

export default SupplierList;
